// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { Reveal } from "@/components/Reveal";
import { PageHero, PageShell } from "@/components/PageShell";
import { ImageGrid } from "@/components/ImageGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/manufacturing/hero.png";
import service1 from "@/assets/manufacturing/service1.png";
import service2 from "@/assets/manufacturing/service2.png";
import service3 from "@/assets/manufacturing/service3.png";
import service4 from "@/assets/manufacturing/service4.png";
import service5 from "@/assets/manufacturing/service5.png";
import service6 from "@/assets/manufacturing/service6.png";
import service7 from "@/assets/manufacturing/service7.png";
import service8 from "@/assets/manufacturing/service8.png";

export const Route = createFileRoute("/$lang/services/manufacturing")({
  head: () => ({
    meta: [
      { title: i18n.t("services/manufacturing:metaTitle", "Aerospace Manufacturing — BIZU Space") },
      {
        name: "description",
        content: i18n.t("services/manufacturing:metaDesc",
          "CNC machining, welding, and precision aerospace component manufacturing."
        ),
      },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/services/manufacturing" }],
  }),
  component: ManufacturingService,
});

function ManufacturingService() {
  const { t } = useTranslation("services/manufacturing");

  return (
    <PageShell>
      {/* Hero */}
      <PageHero
        title={t("heroTitle", " Aerospace Manufacturing")}
        description={t("heroDesc",
          "In BIZU Space we have the capability of manufacturing special aerospace componentes that need CNC and welding. We manufacture propellant tanks, combustion chambers, nozzles, valves and others. We also do hydraulic test in-house all for all our systems."
        )}
        image={heroImage}
      />

      {/* CONTENT */}
      <section className="py-24">
        <div className="container-bizu">
          {/* SYSTEMS ENGINEERING */}
          <Reveal effect="up">
            <p className="text-base leading-relaxed">
              {t("contentDesc",
                "At BIZU Space we have the capability to manufacture complex systems in-house for many applications, including aerospace. This capability includes conventional machining, CNC machining, and special welding including CNC. For these, we have experience manufacturing:"
              )}
            </p>

            <ul className="mt-6 list-disc space-y-2 pl-6 text-base leading-relaxed">
              <li>{t("bullets.b1", "Propellant Tanks")}</li>
              <li>{t("bullets.b2", "Combustion Chambers")}</li>
              <li>{t("bullets.b3", "Nozzles")}</li>
              <li>{t("bullets.b4", "Valves")}</li>
              <li>{t("bullets.b5", "Machining graphyte and ablative materials")}</li>
              <li>{t("bullets.b6", "Injectors")}</li>
              <li>{t("bullets.b7", "Other conventional components")}</li>
            </ul>

            <blockquote className="mt-10 border-l-4 border-accent pl-6 text-lg italic leading-relaxed">
              {t("quote",
                "We can work also with specialized projects, design of machines (we made our own CNC lathe and CNC welding machine) and manufacture your designed project."
              )}
            </blockquote>
          </Reveal>

          <ImageGrid
            className="mt-14"
            columns={4}
            images={[
              service1,
              service2,
              service3,
              service4,
              service5,
              service6,
              service7,
              service8,
            ]}
          />
        </div>
      </section>
    </PageShell>
  );
}
